/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClipDetailsResponse { 
    id: string;
    title?: string;
    text?: string;
    brief?: string;
    lang?: ClipDetailsResponse.LangEnum;
    sourceLang?: string;
    translated?: boolean;
    clipId?: string;
}
export namespace ClipDetailsResponse {
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}